module.exports = __webpack_public_path__ + "img/logo-inverted.5e5c0aef.png";